import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DeliveryReminderComponent } from './delivery-reminder.component';
import { EDayOfWeekToStringPipe } from 'projects/shared/lib/pipes/time/eday-of-week-to-string-pipe/eday-of-week-to-string.pipe';



@NgModule({
  declarations: [
    DeliveryReminderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    EDayOfWeekToStringPipe
  ],
  exports: [
    DeliveryReminderComponent
  ]
})
export class DeliveryReminderModule { }
